// --- İletişim (Plan 2) ---
export const DAILY_MESSAGE_LIMIT = 10;
/** Kullanıcı listesinde sayfa başına satır. */
export const ADMIN_USER_PAGE_SIZE = 25;
export const ADMIN_USER_SORTS = ['created', 'name', 'email', 'status'];
export const ADMIN_USER_STATUS_FILTERS = ['all', 'active', 'suspended'];
export const EMAIL_KINDS = {
    verify: 'E-posta doğrulama',
    reset: 'Şifre sıfırlama',
    match: 'Yeni eşleşme',
    request: 'İletişim talebi',
    request_final: 'İletişim talebi (son)',
    accepted: 'Talep kabul edildi',
    message: 'Mesaj',
    moderation: 'Moderasyon bilgisi',
    account_deleted: 'Hesap silindi',
    contact: 'İletişim formu',
};
/** Moderasyon panelinde bir kullanıcının soy kayıtları. Salt okunur; adres özetleri dönmez. */
export const ADMIN_RECORD_LIMIT = 500;
// --- İletişim formu (footer) ---
export const CONTACT_SUBJECTS = {
    genel: 'Genel soru',
    hesap: 'Hesabımla ilgili',
    gizlilik: 'Gizlilik ve veri talebi',
    hata: 'Hata bildirimi',
    kotuye_kullanim: 'Kötüye kullanım bildirimi',
    oneri: 'Öneri',
    diger: 'Diğer',
};
export const CONTACT_SUBJECT_KEYS = Object.keys(CONTACT_SUBJECTS);
export const CONTACT_MESSAGE_MAX = 4000;
/**
 * Kalibrasyon ölçümleri istemci hatası tablosunda taşınır ama hata değildir.
 * Hem sunucudaki sayaçlar hem moderasyon panelindeki ayrım bu listeyi kullanır;
 * iki yerde ayrı tanımlanırsa kartlar ile listeler birbirini tutmaz.
 */
export const CALIBRATION_MESSAGES = ['calibration', 'hash-timing'];
export const isCalibrationRecord = (message) => CALIBRATION_MESSAGES.includes(message);
//# sourceMappingURL=api-types.js.map